import { UIChunkType, type TurnDegradationPart } from '@myre/app-agent-domain';

import { Component, computed, input } from '@angular/core';
import { isDataUIPart } from 'ai';

import { type MyreUiMessagePart } from '../../interfaces/chat.interfaces';

/**
 * What the turn lost, said next to the answer it qualifies.
 *
 * The card exists so the caveat cannot be dropped on the way to the reader: a
 * turn whose worker crashed, whose tool loop was capped or whose answer failed
 * verification used to arrive looking exactly like a clean one. `message` is
 * worded and localized server-side (like the quota warning), because the server
 * is the only side that knows WHICH of those happened.
 */
@Component({
  selector: 'app-degraded-notice',
  standalone: true,
  templateUrl: './degraded-notice.component.html',
  styleUrl: './degraded-notice.component.scss',
})
export class DegradedNoticeComponent {
  public readonly part = input.required<MyreUiMessagePart>();

  protected readonly _notice = computed<TurnDegradationPart | null>(() => {
    const part = this.part();

    if (!isDataUIPart(part) || part.type !== UIChunkType.DataDegraded) {
      return null;
    }

    return {
      reason: part.data.reason,
      detail: part.data.detail,
      message: part.data.message,
    };
  });
}
